import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight, CalendarClock } from 'lucide-react';
import { Button, Container, Reveal } from './primitives';
import { BOOKING_URL, DISCOVERY_URL } from './constants';
import useGoogleAnalytics from '../../hooks/useGoogleAnalytics';

export default function FinalCTA() {
  const { t } = useTranslation();
  const { events: gaEvents } = useGoogleAnalytics();

  return (
    <section id="contact" className="relative overflow-hidden bg-ink py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0 bg-grid-faint [background-size:42px_42px] [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-80 w-[44rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent opacity-20 blur-[130px]" />

      <Container className="relative">
        <Reveal className="mx-auto max-w-3xl text-center">
          <h2 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
            {t('home.final.title')}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-white/60">{t('home.final.subtitle')}</p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button
              href={BOOKING_URL}
              external
              variant="primary"
              onClick={() => gaEvents.homeBookDemo('final_cta')}
            >
              {t('home.final.cta_primary')}
              <ArrowRight className="h-4 w-4" />
            </Button>
            <Button
              href={DISCOVERY_URL}
              external
              variant="secondary"
              onClick={() => gaEvents.scheduleDiscovery('final_cta')}
            >
              <CalendarClock className="h-4 w-4" />
              {t('home.final.cta_secondary')}
            </Button>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}
